define(['moduler'], function (Moduler) {
    'use strict';
    
    return Moduler.create(null, {
        defaults: {
            event: 'click',
            contentElement: null,
            cssClass: 'u-hidden',
            preventDefault: true,
            once: false,
            toggleSelf: false,
            removeOthers: false,
            removeContainer: 'body',
            preventBodyScroll: false,
            scrollTop: false
        },
        
        init: function () {
            var self = this;

            self.contentElement = document.querySelector(self.options.contentElement);

            self.el.addEventListener(self.options.event, self.toggleVisibility.bind(null, self));

            self.el.addEventListener('toggler-add', function (e) {
                self.add(e, self);
            });

            self.el.addEventListener('toggler-remove', function (e) {
                self.remove(e, self);
            });
        },
    
        remove: function (e, self) {
            if (self.options.toggleSelf) {
                self.el.classList.remove(self.options.cssClass);
            }

            self.contentElement.classList.remove(self.options.cssClass);
            self.contentElement.dispatchEvent(new CustomEvent('toggler-removed'));
        },

        add: function (e, self) {
            if (self.options.toggleSelf) {
                self.el.classList.add(self.options.cssClass);
            }

            self.contentElement.classList.add(self.options.cssClass);
            self.contentElement.dispatchEvent(new CustomEvent('toggler-added'));
        },

        toggleVisibility: function (self, e) {

            if (self.options.preventDefault) {
                e.preventDefault();
            }

            if (self.options.once && self.toggled) {
                return;
            } else if (self.options.once) {
                self.toggled = true;
            }

            if (self.options.toggleSelf) {
                self.el.classList.toggle(self.options.cssClass);
            }

            if (self.options.removeOthers) {
                document.querySelector(self.options.removeContainer).querySelectorAll('[data-module*=toggler]').forEach(element => {
                    if (element !== self.el) {
                        element.dispatchEvent(new CustomEvent('toggler-remove'));
                    }
                });
            }

            self.contentElement.classList.toggle(self.options.cssClass);
            self.contentElement.dispatchEvent(new CustomEvent('toggler-toggeled'));

            if (self.options.scrollTop) {
                self.contentElement.scrollTop = 0;
            }

            if (self.options.preventBodyScroll) {
                document.body.classList.toggle('no-scroll');
            }
        }
    });
});

